import React from "react";
import styles from "../../assets/scss/pagesScss/home.module.scss";
import { solutionsData } from "../../assets/config/config";

export default function SolutionsSection() {
    return (
    <div id="solutions">
        {solutionsData.map((service, index) => (
            <section className={styles.solutions} >
                <div className="container">
                    <div key={index} className={styles.serviceItem}>
                        {/* Left Side - Image */}
                        <div className={styles.imageContainer}>
                            <img src={service.image} alt={service.title} className={styles.serviceImage} />
                        </div>

                        {/* Right Side - Content */}
                        <div className={styles.contentContainer}>
                            <h3 className={styles.serviceTitle}>{service.title}</h3>
                            {service.points.map((point, i) => (
                                <div key={i} className={styles.pointGroup}>
                                    <h4 className={styles.pointHeader}>{point.header}</h4>
                                    <ul className={styles.pointList}>
                                        {point.items.map((item, j) => (
                                            <li key={j} className={styles.pointItem}>
                                                <span>✔</span> {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        ))}
    </div>

    );
}
